/**
 * Referral Domain - i18n Translations
 *
 * @example
 * import { registerReferralTranslations } from 'domains/referral';
 * registerReferralTranslations();
 */

import esReferral from './es-MX/referral.json';

export const referralTranslations = {
  'es-MX': esReferral,
};

export { registerReferralTranslations, areReferralTranslationsLoaded } from './registerTranslations';
